import moment from "moment";

const baseConfig = (addLabel = "Добавить витрину") => ({
    isAdd: (ctx) =>
        [
            {
                label: addLabel,
                icon: "pi pi-check",
                severity: "success",
                action: (e) =>
                    ctx.handleSave(e, {
                        dateStopCampaign: moment().toISOString(),
                    }),
            },
            {
                label: "Сохранить изменения",
                icon: "pi pi-save",
                severity: "info",
                disabled: ctx.disabledUpdateDiff,
                action: (e) =>
                    ctx.handleSave(e, {
                        draft: true,
                        active: false,
                    }),
            },
        ].filter(Boolean),

    isDraft: (ctx) =>
        [
            {
                label: addLabel,
                icon: "pi pi-check",
                severity: "success",
                action: () =>
                    ctx.handleUpdate({
                        active: true,
                        draft: false,
                    }),
            },
            {
                label: "Сохранить изменения",
                icon: "pi pi-save",
                severity: "info",
                action: () => ctx.handleUpdate(),
                disabled: ctx.disabledUpdateDiff,
            },
            {
                label: "Архив",
                icon: "pi pi-inbox",
                severity: "danger",
                action: () =>
                    ctx.confirmArchive({
                        archived: true,
                        active: false,
                        draft: false,
                    }),
            },
        ].filter(Boolean),

    isActive: (ctx) =>
        [
            {
                label: "Сохранить изменения",
                icon: "pi pi-save",
                severity: "info",
                action: () => ctx.handleUpdate(),
                disabled: ctx.disabledUpdataBtn,
            },
            {
                label: "Архив",
                icon: "pi pi-inbox",
                severity: "danger",
                action: () =>
                    ctx.confirmArchive({
                        archived: true,
                        active: false,
                        draft: false,
                    }),
            },
        ].filter(Boolean),
    isInactive: (ctx) =>
        [
            {
                label: `Опубликовать ${!ctx.disabledUpdateDiff ? " с изменениями" : ""}`,
                icon: "pi pi-check",
                severity: "success",
                action: () =>
                    ctx.handleUpdate({
                        active: true,
                        archived: false,
                        draft: false,
                    }),
            },
            !ctx.disabledUpdateDiff && {
                label: "Сохранить изменения",
                icon: "pi pi-save",
                severity: "info",
                action: () => ctx.handleUpdate(),
            },
            {
                label: "Архив",
                icon: "pi pi-inbox",
                severity: "danger",
                action: () =>
                    ctx.confirmArchive({
                        archived: true,
                        active: false,
                        draft: false,
                    }),
            },
        ].filter(Boolean),
});

const bucketConfig = {
    isAdd: (ctx) => [
        {
            label: "Сохранить изменения",
            icon: "pi pi-save",
            severity: "info",
            disabled: ctx.disabledUpdateDiff,
            action: (e) =>
                ctx.handleSave(e, {
                    draft: true,
                    active: false,
                }),
        },
    ],

    isDraft: (ctx) => [
        {
            label: "Сохранить изменения",
            icon: "pi pi-save",
            severity: "info",
            action: () => ctx.handleUpdate(),
            disabled: ctx.disabledUpdateDiff,
        },
        {
            label: "Архив",
            icon: "pi pi-inbox",
            severity: "danger",
            action: () =>
                ctx.confirmArchive({
                    archived: true,
                    active: false,
                    draft: false,
                }),
        },
    ],

    isActive: (ctx) => [
        {
            label: "Сохранить изменения",
            icon: "pi pi-save",
            severity: "info",
            action: () => ctx.handleUpdate(),
            disabled: ctx.disabledUpdataBtn,
        },
        {
            label: "Архив",
            icon: "pi pi-inbox",
            severity: "danger",
            action: () =>
                ctx.confirmArchive({
                    archived: true,
                    active: false,
                    draft: false,
                }),
        },
    ],
};

const abConfig = {
    isAdd: (ctx) => [
        {
            label: "Запустить",
            icon: "pi pi-check",
            severity: "success",
            action: (e) => ctx.handleSave(e),
        },
        {
            label: "Сохранить изменения",
            icon: "pi pi-save",
            severity: "info",
            disabled: ctx.disabledUpdateDiff,
            action: (e) =>
                ctx.handleSave(e, {
                    draft: true,
                    active: false,
                }),
        },
    ],

    isDraft: (ctx) => [
        {
            label: "Запустить",
            icon: "pi pi-check",
            severity: "success",
            action: () =>
                ctx.handleUpdate({
                    active: true,
                    draft: false,
                }),
        },
        {
            label: "Сохранить изменения",
            icon: "pi pi-save",
            severity: "info",
            action: () => ctx.handleUpdate(),
            disabled: ctx.disabledUpdateDiff,
        },
        {
            label: "Архив",
            icon: "pi pi-inbox",
            severity: "danger",
            action: () =>
                ctx.confirmArchive({
                    archived: true,
                    active: false,
                    draft: false,
                }),
        },
    ],

    isActive: (ctx) =>
        [
            !ctx.disabledUpdateDiff && {
                label: `Запустить ${!ctx.disabledUpdateDiff ? " с изменениями" : ""}`,
                icon: "pi pi-check",
                severity: "success",
                action: () =>
                    ctx.handleUpdate({
                        active: true,
                        archived: false,
                        draft: false,
                    }),
            },
            {
                label: "Пауза",
                icon: "pi pi-pause",
                severity: "warning",
                action: () => ctx.handleUpdate({ active: false, archived: false, draft: false }),
            },
            {
                label: "Архив",
                icon: "pi pi-inbox",
                severity: "danger",
                action: () =>
                    ctx.confirmArchive({
                        archived: true,
                        active: false,
                        draft: false,
                    }),
            },
        ].filter(Boolean),
    isArchived: (ctx) => [
        {
            label: "Запустить",
            icon: "pi pi-check",
            severity: "success",
            action: () =>
                ctx.handleUpdate({
                    active: true,
                    draft: false,
                    archived: false,
                }),
        },
    ],
    isInactive: (ctx) =>
        [
            {
                label: `Запустить ${!ctx.disabledUpdateDiff ? " с изменениями" : ""}`,
                icon: "pi pi-check",
                severity: "success",
                action: () =>
                    ctx.handleUpdate({
                        active: true,
                        archived: false,
                        draft: false,
                    }),
            },
            !ctx.disabledUpdateDiff && {
                label: "Сохранить изменения",
                icon: "pi pi-save",
                severity: "info",
                action: () => ctx.handleUpdate(),
            },
            {
                label: "Архив",
                icon: "pi pi-inbox",
                severity: "danger",
                action: () =>
                    ctx.confirmArchive({
                        archived: true,
                        active: false,
                        draft: false,
                    }),
            },
        ].filter(Boolean),
};

export const btnsConfig = {
    companies: {
        isAdd: (ctx) =>
            [
                !(ctx.step < ctx.countOfSteps) && {
                    label: "Опубликовать",
                    icon: "pi pi-check",
                    severity: "success",
                    action: (e) => ctx.confirmPublish(e, { dateStopCampaign: moment().toISOString() }),
                },
                ctx.step <= ctx.countOfSteps && {
                    id: "draft",
                    label: "Сохранить изменения",
                    icon: "pi pi-save",
                    severity: "info",
                    action: (e) => ctx.handleSave(e, { draft: true, active: false }),
                },
            ].filter(Boolean),

        isDraft: (ctx) =>
            [
                {
                    label: "Опубликовать",
                    icon: "pi pi-check",
                    severity: "success",
                    disabled: ctx.eridToRegenerate === "required",
                    action: () =>
                        ctx.eridToRegenerate === "optional"
                            ? ctx.confirmEridGenerate({
                                  active: true,
                                  draft: false,
                                  archived: false,
                                  dateStopCampaign: moment().toISOString(),
                              })
                            : ctx.confirmPublishUpdataChanges({
                                  active: true,
                                  draft: false,
                                  archived: false,
                                  dateStopCampaign: moment().toISOString(),
                              }),
                },
                !ctx.disabledUpdateDiff && {
                    label: "Сохранить изменения",
                    icon: "pi pi-save",
                    severity: "info",
                    disabled: ctx.eridToRegenerate === "required",
                    action: () => (ctx.eridToRegenerate === "optional" ? ctx.confirmEridGenerate({}, true) : ctx.handleUpdate()),
                },
                {
                    label: "Архив",
                    icon: "pi pi-inbox",
                    severity: "danger",
                    action: () =>
                        ctx.confirmArchive({
                            archived: true,
                            active: false,
                            draft: false,
                            dateStopCampaign: moment().toISOString(),
                        }),
                },
            ].filter(Boolean),

        isActive: (ctx) =>
            [
                !ctx.disabledUpdateDiff && {
                    label: "Опубликовать с изменениями",
                    icon: "pi pi-check",
                    severity: "success",
                    disabled: ctx.eridToRegenerate === "required",
                    action: () => (ctx.eridToRegenerate === "optional" ? ctx.confirmEridGenerate({ dateStopCampaign: moment().toISOString() }) : ctx.confirmPublishUpdata({ dateStopCampaign: moment().toISOString() })),
                },
                {
                    label: "Клонировать оффер",
                    icon: "pi pi-copy",
                    severity: "help",
                    action: () => ctx.handleClone(),
                },
                {
                    label: "Пауза",
                    icon: "pi pi-pause",
                    severity: "warning",
                    action: () => ctx.handleUpdate({ active: false, archived: false, draft: false }),
                },
                {
                    label: "Архив",
                    icon: "pi pi-inbox",
                    severity: "danger",
                    action: () =>
                        ctx.confirmArchive({
                            archived: true,
                            active: false,
                            draft: false,
                            dateStopCampaign: moment().toISOString(),
                        }),
                },
            ].filter(Boolean),

        isArchived: (ctx) =>
            [
                {
                    label: "Клонировать оффер",
                    icon: "pi pi-copy",
                    severity: "help",
                    action: () => ctx.handleClone(),
                },
            ].filter(Boolean),

        isInactive: (ctx) =>
            [
                {
                    label: `Опубликовать${!ctx.disabledUpdateDiff ? " с изменениями" : ""}`,
                    icon: "pi pi-check",
                    severity: "success",
                    disabled: ctx.eridToRegenerate === "required",
                    action: !ctx.disabledUpdateDiff
                        ? () =>
                              ctx.eridToRegenerate === "optional"
                                  ? ctx.confirmEridGenerate({
                                        active: true,
                                        archived: false,
                                        draft: false,
                                        dateStopCampaign: moment().toISOString(),
                                    })
                                  : ctx.confirmPublishUpdata({
                                        active: true,
                                        archived: false,
                                        draft: false,
                                        dateStopCampaign: moment().toISOString(),
                                    })
                        : () =>
                              ctx.eridToRegenerate === "optional"
                                  ? ctx.confirmEridGenerate({
                                        active: true,
                                        archived: false,
                                        draft: false,
                                        dateStopCampaign: moment().toISOString(),
                                    })
                                  : ctx.confirmPublishUpdataChanges({
                                        active: true,
                                        archived: false,
                                        draft: false,
                                        dateStopCampaign: moment().toISOString(),
                                    }),
                },
                !ctx.disabledUpdateDiff && {
                    label: "Сохранить изменения",
                    icon: "pi pi-save",
                    severity: "info",
                    disabled: ctx.eridToRegenerate === "required",
                    action: () => (ctx.eridToRegenerate === "optional" ? ctx.confirmEridGenerate({}, true) : ctx.handleUpdate()),
                },
                {
                    label: "Клонировать оффер",
                    icon: "pi pi-copy",
                    severity: "help",
                    action: () => ctx.handleClone(),
                },
                {
                    label: "Архив",
                    icon: "pi pi-inbox",
                    severity: "danger",
                    action: () =>
                        ctx.confirmArchive({
                            archived: true,
                            active: false,
                            draft: false,
                            dateStopCampaign: moment().toISOString(),
                        }),
                },
            ].filter(Boolean),
    },

    offers: baseConfig(),
    projects: baseConfig(),
    "test-offer": abConfig,
    "replace-data": abConfig,
    "test-site": abConfig,
    "buckets-add": bucketConfig,
};
